import { render, staticRenderFns } from "./TenantModify.vue?vue&type=template&id=18cefc80"
import script from "./TenantModify.vue?vue&type=script&lang=js"
export * from "./TenantModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports